// extracted by mini-css-extract-plugin
export var container = "_ho-1";
export var cornerButtonContainer = "_ho-6";
export var disabled = "_ho-2";
export var dragActive = "_ho-3";
export var fileContainer = "_ho-5";
export var hiddenInput = "_ho-4";
export var widthContainer = "_ho-0";